import { Component, Input, ViewChild, OnInit, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Table as PrimeDataTable } from 'primeng/table';
import { ReplaceWithEmailTypeConfig } from '../../../shared/index';
import { ProfileService } from '../../../../profiles/shared/profile.service';
import { EmailAddressType } from '../../../../profiles/shared/email-address-type.model';
/**
 * edit a single mass comm message
 */
@Component({
  selector: 'wl-mass-comm-message-edit-profiles-email-type-config',
  templateUrl: 'mass-comm-message-edit-profiles-email-type-config.component.html',
  styleUrls: [],
    standalone: false
})
export class MassCommMessageEditProfilesEmailTypeConfigComponent implements OnInit {
  @Input() public replaceWithEmailTypeConfig: ReplaceWithEmailTypeConfig = null;

  public emailTypes: EmailAddressType[] = [];

  /**
   * inject
   */
  public constructor(private _profileService: ProfileService) {}

  /**
   * initter
   */
  public async ngOnInit(): Promise<void> {
    let typesResult = await this._profileService.searchEmailTypes({
      PageNumber: 0,
      PageSize: 0,
      OrderBy: 'Name',
    });

    if (typesResult && typesResult.Result) this.emailTypes = typesResult.Result;
  }

  /**
   * add/remove email address type from selected types
   */
  public handleEmailTypeCheckboxClick($event: any, emailTypeId: number): void {
    let checked: boolean = $event && $event.target && $event.target.checked;

    if (checked && this.replaceWithEmailTypeConfig.EmailAddressTypeIds.indexOf(emailTypeId) < 0) {
      this.replaceWithEmailTypeConfig.EmailAddressTypeIds.push(emailTypeId);
    } else if (!checked) {
      let i = this.replaceWithEmailTypeConfig.EmailAddressTypeIds.indexOf(emailTypeId);

      if (i >= 0) this.replaceWithEmailTypeConfig.EmailAddressTypeIds.splice(i, 1);
    }
  }
}
